<div class="container mx-auto px-4">
  <div class="flex flex-wrap gap-x-4">
    @for (item of grade_list; track item; let i = $index) {
      <div class="w-1/2 sm:w-1/4" style="width: 50px; height: 50px;">
        <button type="button" class="daisy-btn w-full" [ngClass]="item.selected ? 'daisy-btn-primary' : 'daisy-btn-secondary'"  (click)="changeState(i)">{{ item.text }}</button>
      </div>
    }
  </div>
</div>
